// extracted by mini-css-extract-plugin
export default {"container":"UserForms_container__Hvdd6","form":"UserForms_form__XCS2x"};